import { X } from "@/components/ui/icons";

import { FilterPill } from "@/components/filters/FilterPill";
import { appliedChips, type Facet } from "@/lib/filters/facet";
import { useThemeColors } from "@/theme/theme";

/**
 * One removable pill per applied value, so the list says what is narrowing it without the sheet
 * being opened. Removing one returns only that value to rest: a whole facet for a single-select
 * facet, one value of a multi-select one.
 */
export function AppliedFilterChips<P>(
  { facets, onChange }: { facets: Facet<P>[]; onChange: (patch: P) => void; },
) {
  const c = useThemeColors();
  return (
    <>
      {appliedChips(facets).map((chip) => (
        <FilterPill
          key={chip.key}
          testID={`applied-filter-${chip.key}`}
          label={chip.label}
          active
          onPress={() => onChange(chip.remove())}
          a11yLabel={`Remove ${chip.facetLabel.toLowerCase()} filter: ${chip.label}`}
          trailing={<X size={12} color={c.foreground} aria-hidden />}
        />
      ))}
    </>
  );
}
